import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const form = useRef();
  // const [isSuccess, setIsSuccess] = useState(false);
  const [isBgColor, setIsBgColor] = useState("");
  const [isMessage, setIsMessage] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();

    // Validate input fields
    const firstName = form.current.firstName.value.trim();
    const lastName = form.current.lastName.value.trim();
    const email = form.current.email.value.trim();
    const message = form.current.message.value.trim();

    if (!firstName || !lastName || !email || !message) {
      // Handle case when any field is empty
      setIsBgColor("text-amber-600");
      setIsMessage("Please fill in all fields.");
      return;
    }
    // Validate email using regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setIsBgColor("text-amber-600");
      setIsMessage("Please enter a valid email address.");
      return;
    }
    emailjs
      .sendForm(
        "service_waxgzyt",
        "template_2dx4gd7",
        form.current,
        "cqB0JNFochFyIESdU"
      )
      .then(
        (result) => {
          // console.log(result.text);
          // setIsSuccess((current) => !current);
          setIsBgColor("text-green-600");
          setIsMessage("Message Sent Successfully");
        },
        (error) => {
          // console.log(error.text);
          setIsBgColor("text-rose-600");
          setIsMessage("Message Sending Unsuccessful");
        }
      );
  };
  return (
    <>
      <div
        id="contact"
        className="bg-contact h-[100vmin] bg-fill bg-no-repeat text-white bg-[center_bottom] pt-12 px-[4.4rem]"
      >
        <h2 className="m-4 text-[5vmin] font-bold">Contact</h2>
        <form className="grid justify-center" ref={form} onSubmit={sendEmail}>
          <div className="grid justify-center mt-16 w-full ">
            <div className="grid grid-cols-2 gap-[4vmin]">
              <div className="w-full">
                <input
                  className="w-[40vmin] rounded-3xl h-[50px] bg-white backdrop-blur bg-white/10 border-2 pl-2"
                  type="text"
                  name="firstName"
                  id=""
                  placeholder="First Name"
                />
              </div>
              <div className="w-full">
                <input
                  className="w-[40vmin] rounded-3xl h-[50px] bg-white backdrop-blur bg-white/10 border-2 pl-3"
                  type="text"
                  name="lastName"
                  id=""
                  placeholder="Last Name"
                />
              </div>
            </div>
            <div className="grid   mt-8">
              <div className="w-full">
                <input
                  className="w-[84vmin] rounded-3xl h-[50px] bg-white backdrop-blur bg-white/10 border-2 pl-2"
                  type="text"
                  name="email"
                  id=""
                  placeholder="Email"
                />
              </div>
            </div>
            <div className="grid  mt-8">
              <div className="w-full">
                <textarea
                  className="w-[84vmin] rounded-3xl h-[300px] bg-white backdrop-blur bg-white/10 border-2 p-2 "
                  type="text"
                  name="message"
                  id=""
                  placeholder="Message"
                />
              </div>
            </div>
            <div className="h-[1.8vmin] text-center p-6 w-full grid justify-center">
              <p className={isBgColor}>{isMessage}</p>
            </div>
          </div>

          <div className="grid justify-center mt-8">
            <button className="px-12 py-4 border-4 rounded-full" type="submit">
              Send Message
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default Contact;
